export const formatPhoneNumberWithDashes = (phoneNumber?: string) =>
  phoneNumber?.length === 10 && !isNaN(Number(phoneNumber))
    ? `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(
        3,
        6
      )}-${phoneNumber.substring(6, 10)}`
    : phoneNumber;

export const stripPhoneNumberInputValue = (str: string | undefined) =>
  str?.replace(/\D/g, '').substring(0, 10);

export const formatPhoneNumberInputValue = (str: string | undefined) => {
  const stripped = stripPhoneNumberInputValue(str);
  if (!stripped) {
    return '';
  }

  const area = stripped.substring(0, 3);
  const start = stripped.substring(3, 6);
  const end = stripped.substring(6, 10);
  if (area.length === 3 && start.length === 3 && end.length >= 1) {
    return `(${area}) ${start}-${end}`;
  }

  if (
    area.length === 3 &&
    start.length >= 1 &&
    start.length <= 3 &&
    end.length <= 0
  ) {
    return `(${area}) ${start}`;
  }
  if (area.length <= 3) {
    return `(${area}`;
  }
};
